import { Wifi, WifiOff, RefreshCw, AlertTriangle } from "lucide-react";
import { useState, useEffect } from "react";

export default function SyncStatus() {
  const [online, setOnline] = useState(navigator.onLine);
  const [pendingCount, setPendingCount] = useState(0);

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);

    // Check pending sync items
    const checkPending = async () => {
      try {
        if (window.archonOfflineStore) {
          const count = await window.archonOfflineStore.getPendingCount();
          setPendingCount(count);
        }
      } catch { /* ignore */ }
    };
    checkPending();
    const interval = setInterval(checkPending, 5000);

    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
      clearInterval(interval);
    };
  }, []);

  if (online && pendingCount === 0) return null;

  return (
    <div data-testid="sync-status" className="flex items-center gap-2">
      {!online && (
        <div className="flex items-center gap-1.5 px-2.5 py-1 rounded-sm bg-red-50 border border-red-200 text-red-700 text-xs font-medium">
          <WifiOff size={12} /> Offline
        </div>
      )}
      {pendingCount > 0 && (
        <div className="flex items-center gap-1.5 px-2.5 py-1 rounded-sm bg-yellow-50 border border-yellow-200 text-yellow-700 text-xs font-medium">
          <RefreshCw size={12} className="animate-spin" /> {pendingCount} pending sync
        </div>
      )}
    </div>
  );
}
